import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { webpToPng } from "@/js/images";
export default {
  name: "Uploader",
  // vue component name
  data: function data() {
    return {
      error: "",
      files: [],
      dropped: 0,
      Imgs: []
    };
  },
  props: {
    uploadMsg: String,
    extensionsAllowed: Array
  },
  methods: {
    dragOver: function dragOver() {
      this.dropped = 2;
    },
    dragLeave: function dragLeave() {},
    drop: function drop(e) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _e$dataTransfer;
        var files, isAvailable, _this2$files, processedFiles;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              files = Array.from((_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 ? void 0 : _e$dataTransfer.files);
              if (!(e && files)) {
                _context.next = 12;
                break;
              }
              isAvailable = _this2.checkFilesCompatibility(files);
              if (!isAvailable) {
                _context.next = 11;
                break;
              }
              _context.next = 6;
              return _this2.processFiles(files);
            case 6:
              processedFiles = _context.sent;
              (_this2$files = _this2.files).push.apply(_this2$files, _toConsumableArray(processedFiles));
              _this2.previewImgs();
              _context.next = 12;
              break;
            case 11:
              _this2.reset();
            case 12:
              _this2.dropped = 0;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    filesPicked: function filesPicked(e) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _e$currentTarget;
        var files, isAvailable, _this3$files, processedFiles;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              files = Array.from((_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.files);
              if (!(e && files)) {
                _context2.next = 12;
                break;
              }
              isAvailable = _this3.checkFilesCompatibility(files);
              if (!isAvailable) {
                _context2.next = 11;
                break;
              }
              _context2.next = 6;
              return _this3.processFiles(files);
            case 6:
              processedFiles = _context2.sent;
              (_this3$files = _this3.files).push.apply(_this3$files, _toConsumableArray(processedFiles));
              _this3.previewImgs();
              _context2.next = 12;
              break;
            case 11:
              _this3.reset();
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    processFiles: function processFiles(files) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var processedFiles, _iterator, _step, file, pngBlob, pngFile;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              processedFiles = [];
              _iterator = _createForOfIteratorHelper(files);
              _context3.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context3.next = 23;
                break;
              }
              file = _step.value;
              if (!(file.type === "image/webp")) {
                _context3.next = 20;
                break;
              }
              _context3.prev = 7;
              _context3.next = 10;
              return webpToPng(file);
            case 10:
              pngBlob = _context3.sent;
              pngFile = new File([pngBlob], file.name.replace(/\.webp$/i, ".png"), {
                type: "image/png",
                lastModified: file.lastModified
              });
              processedFiles.push(pngFile);
              _context3.next = 18;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](7);
              _this4.$toasted.show("Impossible to convert Webp to Png.", {
                type: "error"
              });
            case 18:
              _context3.next = 21;
              break;
            case 20:
              processedFiles.push(file);
            case 21:
              _context3.next = 4;
              break;
            case 23:
              _context3.next = 28;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t1 = _context3["catch"](2);
              _iterator.e(_context3.t1);
            case 28:
              _context3.prev = 28;
              _iterator.f();
              return _context3.finish(28);
            case 31:
              return _context3.abrupt("return", processedFiles);
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 25, 28, 31], [7, 15]]);
      }))();
    },
    checkFilesCompatibility: function checkFilesCompatibility(currentFiles) {
      var _this5 = this;
      var isAvailable = true;
      currentFiles === null || currentFiles === void 0 || currentFiles.forEach(function (file) {
        var _this5$extensionsAllo;
        if (file.type.startsWith("image") === false) {
          _this5.error = "Unsupported file type, must be an image";
          isAvailable = false;
        }
        if (((_this5$extensionsAllo = _this5.extensionsAllowed) === null || _this5$extensionsAllo === void 0 ? void 0 : _this5$extensionsAllo.length) > 0) {
          if (!File.isExtensionAllowed(file.name, _this5.extensionsAllowed)) {
            _this5.error = "File extension (.".concat(File.getExtension(file.name), ") not allowed");
            isAvailable = false;
          }
        }
      });
      if (isAvailable) {
        this.error = "";
      }
      return isAvailable;
    },
    append: function append() {
      this.$refs.uploadInput.click();
    },
    readAsDataURL: function readAsDataURL(file) {
      return new Promise(function (resolve, reject) {
        var fr = new FileReader();
        fr.onload = function () {
          file.base64 = fr.result;
          resolve(fr.result);
        };
        fr.onerror = function () {
          reject(fr);
        };
        fr.readAsDataURL(file);
      });
    },
    deleteImg: function deleteImg(index) {
      this.Imgs.splice(index, 1);
      this.files.splice(index, 1);
      this.$emit("change", this.files);
      this.$refs.uploadInput.value = null;
    },
    previewImgs: function previewImgs() {
      var readers = [];
      if (!this.files.length) return;
      for (var i = 0; i < this.files.length; i++) {
        readers.push(this.readAsDataURL(this.files[i]));
      }
      var _this = this;
      Promise.all(readers).then(function (values) {
        _this.Imgs = values;
        _this.$emit("change", _this.files);
      });
    },
    reset: function reset() {
      this.$refs.uploadInput.value = null;
      this.Imgs = [];
      this.files = [];
      this.$emit("change", this.files);
    }
  }
};